import { AxiosRequestConfig, AxiosResponse } from "axios";
import api from "../../../context-module/context-configuration/auth-provider/apiGroup/api";

const ApiGet = <T = unknown>(
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  return api.get<T>(url, config);
};

export default ApiGet;
